import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  user: FormGroup;
  spinner: boolean;

  constructor(
    private fb: FormBuilder,
    private authService: LoginService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.crearFormulario();
  }

  ngOnInit(): void {}

  get correoNoValido(): any {
    return this.user.get('email').invalid && this.user.get('email').touched;
  }

  crearFormulario(): any {
    this.user = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  guardar(): any {
    if (this.user.invalid) {
      return Object.values(this.user.controls).forEach((control) => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach((ctrl) =>
            ctrl.markAsTouched()
          );
        } else {
          control.markAsTouched();
        }
      });
    }
    Swal.fire({
      title: '',
      html: 'Espere por favor....!!',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    console.log(this.user.value);

    this.authService.forgotPassword(this.user.value).subscribe(
      (datas) => {
        if (datas) {
          Swal.close();
          Swal.fire({
            icon: 'success',
            text: 'Se ha enviado un correo para el cambio de contraseña',
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/public/login/'], {
                relativeTo: this.route,
              });
            }
          });
        }
      },
      (error) => {
        console.log(error);
        Swal.fire('', 'Hubo un error en el envio del correo', 'warning');
      }
    );
  }

  onLogin(): any {
    this.router.navigate(['login'], { relativeTo: this.route.parent });
  }
}
